import { SET_HEADER_HEIGHT } from '@state/actions/app'

const defaultState = {}

const songsReducer = (state = defaultState, action) => {
    // console.log("app reducer action = ", action)

    switch (action.type) {
        case 'SET_SONGS':
            return Object.assign({}, state, {
                songs: action.songs,
            })

        case 'SET_VERSIONS':
            return Object.assign({}, state, {
                versions: action.versions,
            })

        default:
            return state
    }
}

export default songsReducer
